import styled from 'styled-components'

export const Wrapper = styled.div`
  visibility: none;
  max-height: 0;
  max-width: 0;
  z-index: -999;
  position: absolute;
  top: 0;
`;

export const Input = styled.input`
  visibility: none;
`;
